<template>
  <div class="settings-container">
    <p class="title">
      Settings
    </p>

    <div class="setting-wrapper">
      <div class="setting-item">
        <span class="setting-title">Paused</span>
        <div class="setting-value">
          <span class="value">{{ projectData.paused }}</span>
          <button class="actionBtn" @click="onPausedClick">
            Edit
          </button>
        </div>
      </div>

      <div class="setting-item">
        <span class="setting-title">Locked</span>
        <div class="setting-value">
          <span class="value">{{ projectData.locked }}</span>
        </div>
      </div>

      <div class="setting-item">
        <span class="setting-title">Base API</span>
        <div class="api-value">
          <p class="value">
            {{ projectData.projectBaseURI }}
          </p>
          <!-- <p class="value">
            http://59.110.68.178:8004/api/creature/
          </p> -->
        </div>
        <div class="action">
          <button class="actionBtn site" @click="onbaseApiClick">
            Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchProjectDetail, fetchProjectPaused, updateProjectbaseURI } from '@/contactLogic/manage/index';
import { mapState } from 'vuex';
import event from '@/common/utils/event.js';
export default {
  data() {
    return {
      projectData: {},
    };
  },
  computed: {
    ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
    isReady() {
      return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
    },
  },
  methods: {
    getParams() {
      return {
        web3: this.web3,
        library: this.ethersprovider,
        account: this.ethAddress,
        chainID: this.ethChainID,
        projectId: this.$route.params.projectId,
      };
    },
    async getProjectDetail() {
      try {
        const params = this.getParams();
        const detailData = await fetchProjectDetail(params);
        this.projectData = detailData;
      } catch (error) {
        console.log(error);
      }
    },

    async onPausedClick() {
      try {
        const params = this.getParams();
        const res = await fetchProjectPaused({
          ...params,
          projectId: this.$route.params.projectId,
        });
        if (res) {
          this.$Notice.success({
            title: 'success',
            desc: 'Successfully send transaction',
            duration: 10,
          });
          event.$emit('sendtx', [
            res,
            {
              okinfo: `Edit Paused Success!`,
              failinfo: `Edit Paused Failed！`,
            },
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onbaseApiClick() {
      try {
        const params = this.getParams();
        const res = await updateProjectbaseURI({
          ...params,
          projectId: this.$route.params.projectId,
        });
        if (res) {
          this.$Notice.success({
            title: 'success',
            desc: 'Successfully send transaction',
            duration: 10,
          });
          event.$emit('sendtx', [
            res,
            {
              okinfo: `Edit BaseApi Success!`,
              failinfo: `Edit BaseApi Failed！`,
            },
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    isReady() {
      this.getProjectDetail();
    },
  },
  created() {
    this.getProjectDetail();
  },
  mounted() {
    event.$on('txsuccess', () => {
      this.getProjectDetail();
    });
  },
};
</script>

<style lang="less" scoped>
.settings-container {
  width: 100%;
  .title {
    padding-top: 20px;
    margin-bottom: 20px;
    text-align: left;
    font-size: 20px;
    font-weight: 600;
  }
  .setting-wrapper {
    width: 60%;
    margin: 0 auto;
    .setting-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 12px 0px;
      border-bottom: 1px solid rgba(241, 241, 241, 0.3);
      margin-bottom: 20px;
      .setting-title {
        width: 30%;
        font-size: 18px;
      }
      .setting-value {
        width: 70%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .value {
          font-size: 16px;
          // text-align: left;
        }
        .actionBtn {
          // text-align: right;
          color: #86b5db;
          font-size: 16px;
        }
      }
      .api-value {
        width: 60%;
        .value {
          font-size: 16px;
          padding: 5px 0px;
        }
      }
      .action {
        width: 10%;
        text-align: right;
      }
    }
  }
}
</style>